import { FC } from "react";
import { partners as defaultPartners } from "./constant";

export interface Partner {
  src: string;
  alt: string;
  className?: string;
}

interface Props {
  title?: string;
  partners?: Partner[];
}

export const PartnerSection: FC<Props> = ({
  title = "Users that Trust Us",
  partners = defaultPartners,
}) => {
  return (
    <section className="bg-white">
      <div className="py-12 px-4 md:px-16">
        <div className="flex flex-col items-center gap-8 referral-container">
          <p className="text-ashShade-16 text-xl font-semibold font-satoshi text-center">
            {title}
          </p>
          <div className="grid grid-cols-3 lg:flex items-center gap-10 place-items-center">
            {partners.map((partner) => (
              <img
                src={partner.src}
                alt={partner.alt}
                className="object-contain"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
